import { render, staticRenderFns } from "./WallboardPreview.vue?vue&type=template&id=c1dd1e86&scoped=true&"
import script from "./WallboardPreview.vue?vue&type=script&lang=js&"
export * from "./WallboardPreview.vue?vue&type=script&lang=js&"
import style0 from "./WallboardPreview.vue?vue&type=style&index=0&id=c1dd1e86&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1dd1e86",
  null
  
)

export default component.exports